import { useState } from "react";
import styles from "./styles.module.css";
import Container from "../Container";
import Button from "../Button";
import ArrowLink from "../ArrowLink";
import Heading from "../Heading";
import Image from "next/image";
import Link from "next/link";
import { Search } from "../Icons";
import cn from "classnames";

const ResourcesSearch = ({ onChange, value }) => {
  const [isActive, setActive] = useState(false);
  return (
    <div className={styles.resourcesSearch}>
      <Search onClick={() => setActive(!isActive)} />
      <input
        className={cn(styles.input, { [styles.inputActive]: isActive })}
        type="text"
        onChange={onChange}
        value={value}
      />
    </div>
  );
};

export default ResourcesSearch;
